import { queryOptions, useSuspenseQuery } from "@tanstack/react-query";
import { fetchRoiVsSpend } from "../api/enterpriseClient";

export const roiVsSpendQueryOptions = (customerId: number) =>
  queryOptions({
    queryKey: ["enterprise-roi-vs-spend", customerId],
    queryFn: () => fetchRoiVsSpend(customerId),
    staleTime: 60_000,
  });

export function useGetRoiVsSpend(customerId: number) {
  return useSuspenseQuery(roiVsSpendQueryOptions(customerId));
}
